import React from 'react';

const NiraResetPasswordDialog = ({ onClose, onSubmit, title }) => {
  const [form, setForm] = React.useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = React.useState({});
  const [submitting, setSubmitting] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const errs = {};
    if (!form.newPassword?.trim()) errs.newPassword = 'New password is required';
    if (!form.confirmPassword?.trim()) errs.confirmPassword = 'Confirm password is required';
    if (
      form.newPassword?.trim() &&
      form.confirmPassword?.trim() &&
      form.newPassword.trim() !== form.confirmPassword.trim()
    ) {
      errs.confirmPassword = 'Passwords do not match';
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!validate()) return;
    try {
      setSubmitting(true);
      await onSubmit?.({
        newPassword: form.newPassword.trim(),
        confirmPassword: form.confirmPassword.trim(),
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="react-confirm-alert">
      <div
        className="react-confirm-alert-overlay"
        onClick={() => {
          if (!submitting) onClose?.();
        }}
      >
        <div
          className="react-confirm-alert-body"
          style={{ maxWidth: 520, width: '100%', position: 'relative' }}
          onClick={(e) => e.stopPropagation()}
        >
          {submitting && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'rgba(0, 0, 0, 0.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                borderRadius: 'var(--border-radius)'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 10,
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 16
                }}
              >
                <i className="fas fa-spinner fa-spin" style={{ fontSize: 28 }}></i>
                Submitting request...
              </div>
            </div>
          )}

          <h3 style={{ marginBottom: 12 }}>
            <i className="fas fa-lock"></i> {title || 'Reset NIRA Password'}
          </h3>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>New Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showNewPassword ? 'text' : 'password'}
                  name="newPassword"
                  value={form.newPassword}
                  onChange={handleChange}
                  placeholder="Enter new password"
                  disabled={submitting}
                />
                <span
                  className="password-toggle-icon"
                  onClick={() => !submitting && setShowNewPassword((v) => !v)}
                  title={showNewPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={showNewPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                </span>
              </div>
              {errors.newPassword && <div className="error-text">{errors.newPassword}</div>}
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmPassword"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  placeholder="Re-enter new password"
                  disabled={submitting}
                />
                <span
                  className="password-toggle-icon"
                  onClick={() => !submitting && setShowConfirmPassword((v) => !v)}
                  title={showConfirmPassword ? 'Hide password' : 'Show password'}
                >
                  <i className={showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                </span>
              </div>
              {errors.confirmPassword && <div className="error-text">{errors.confirmPassword}</div>}
            </div>

            <div className="react-confirm-alert-button-group" style={{ marginTop: 16 }}>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Resetting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-key"></i> Reset Password
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NiraResetPasswordDialog;
